import { createRouter, createWebHistory } from 'vue-router'
import request from '@/api/request'

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      { path: '', name: 'Home', component: () => import('@/views/Home.vue'), meta: { title: '首页' } },
      { path: 'about', name: 'About', component: () => import('@/views/about/About.vue'), meta: { title: '关于我们' } },
      { path: 'about/history', name: 'History', component: () => import('@/views/about/History.vue'), meta: { title: '发展历程' } },
      { path: 'about/honor', name: 'Honor', component: () => import('@/views/about/Honor.vue'), meta: { title: '资质荣誉' } },
      { path: 'products', name: 'ProductList', component: () => import('@/views/products/ProductList.vue'), meta: { title: '产品中心' } },
      { path: 'products/:id', name: 'ProductDetail', component: () => import('@/views/products/ProductDetail.vue'), meta: { title: '产品详情' } },
      { path: 'solutions', name: 'SolutionList', component: () => import('@/views/solutions/SolutionList.vue'), meta: { title: '解决方案' } },
      { path: 'solutions/:id', name: 'SolutionDetail', component: () => import('@/views/solutions/SolutionDetail.vue'), meta: { title: '方案详情' } },
      { path: 'services', name: 'Services', component: () => import('@/views/services/Services.vue'), meta: { title: '服务支持' } },
      { path: 'services/repair', name: 'Repair', component: () => import('@/views/services/Repair.vue'), meta: { title: '在线报修' } },
      { path: 'cases', name: 'CaseList', component: () => import('@/views/cases/CaseList.vue'), meta: { title: '成功案例' } },
      { path: 'cases/:id', name: 'CaseDetail', component: () => import('@/views/cases/CaseDetail.vue'), meta: { title: '案例详情' } },
      { path: 'news', name: 'NewsList', component: () => import('@/views/news/NewsList.vue'), meta: { title: '新闻资讯' } },
      { path: 'news/:id', name: 'NewsDetail', component: () => import('@/views/news/NewsDetail.vue'), meta: { title: '新闻详情' } },
      { path: 'jobs', name: 'JobList', component: () => import('@/views/jobs/JobList.vue'), meta: { title: '人才招聘' } },
      { path: 'jobs/:id', name: 'JobDetail', component: () => import('@/views/jobs/JobDetail.vue'), meta: { title: '岗位详情' } },
      { path: 'contact', name: 'Contact', component: () => import('@/views/contact/Contact.vue'), meta: { title: '联系我们' } },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0, behavior: 'smooth' }
  },
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
    ? `${to.meta.title} - 江苏百尔智能装备`
    : '江苏百尔智能装备 - 智能装备 · 智造未来'
  next()
})

// ========== 访客行为追踪 ==========
// 同一访客在 30 分钟内为一次会话，后端只记录一条，含访问页面序列和总停留时长
const VISITOR_KEY = 'baier_visitor_id'

function getVisitorId() {
  let id = localStorage.getItem(VISITOR_KEY)
  if (!id) {
    id = 'v_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10)
    localStorage.setItem(VISITOR_KEY, id)
  }
  return id
}

function reportVisit(url, duration) {
  request.post('/website/visit/beat', { visitorId: getVisitorId(), url, duration }).catch(() => {})
}

let currentUrl = location.pathname + location.search
let enterTime = Date.now()

// 页面切换：上报上一页的停留时长，再进入新页
router.afterEach((to) => {
  const now = Date.now()
  const duration = Math.round((now - enterTime) / 1000)
  if (currentUrl !== to.fullPath) {
    reportVisit(currentUrl, duration)
    currentUrl = to.fullPath
    enterTime = now
  }
})

// 页面关闭/刷新：用 sendBeacon 上报当前页停留时长（可靠，不会被取消）
window.addEventListener('beforeunload', () => {
  const duration = Math.round((Date.now() - enterTime) / 1000)
  const payload = JSON.stringify({ visitorId: getVisitorId(), url: currentUrl, duration })
  if (navigator.sendBeacon) {
    navigator.sendBeacon('/baier/website/visit/beat', new Blob([payload], { type: 'application/json' }))
  } else {
    reportVisit(currentUrl, duration)
  }
})

export default router
